module.exports = {"env":"","host":{"m":"172.27.0.102","kc":"172.28.0.20","yiapi":"172.27.0.102","www":"172.27.0.102"},"domain":{"MEDI_ORIGIN":{"m_safe":"medi.onexinli.com","m_warn":"hd.onexinli.com","m_risk":""},"XY_ORIGIN":{"m_safe":"m-xy.xinli001.com","m_warn":"mhd-xy.xinli001.com","m_risk":"m-xy.xinli001.com","s_safe":"s-xy.xinli001.com","s_warn":"shd-xy.xinli001.com","s_risk":"s-xy.xinli001.com"}}}


//////////////////
// WEBPACK FOOTER
// ./yxlConfig.json
// module id = 346
// module chunks = 115